import React from 'react';
import styles from './DecorativeMenuButton.module.css';

export interface DecorativeMenuButtonProps {
  onClick?: () => void;
  isOpen?: boolean;
  className?: string;
  'aria-label'?: string;
  variant?: 'default' | 'white';
}

export const DecorativeMenuButton: React.FC<DecorativeMenuButtonProps> = ({
  onClick,
  isOpen = false,
  className = '',
  'aria-label': ariaLabel = 'Toggle menu',
  variant = 'default',
}) => {
  return (
    <button
      className={`${styles.menuButton} ${className}`}
      onClick={onClick}
      aria-label={ariaLabel}
      aria-expanded={isOpen}
      type="button"
    >
      {/* Two decorative rectangles */}
      <span
        className={`${styles.rectangle} ${styles.top} ${variant === 'white' ? styles.white : ''}`}
      />
      <span
        className={`${styles.rectangle} ${styles.bottom} ${variant === 'white' ? styles.white : ''}`}
      />
    </button>
  );
};
